import { Component} from '@angular/core';
// ---------------------------------------------------------------------
@Component({
  selector: 'lib-loader-svg',
  templateUrl: './loader.component.svg',
  styleUrls: ['./loader.component.scss']
})
export class LoaderSvgComponent { }

